import {
  AddressActions,
  AddressState,
  CalendarActions,
  CalendarState,
  PackageActions,
  PackageState,
} from '@raskrask-dk/bookingflow-state-machine'
import { ReactElement } from 'react'
import { PartnerBF, ServiceBF } from '../../../models'
import { useBFSMValue } from '../../../services/hooks/useBFSMValues'
import AddressResetTemplate from './template'

const AddressResetPage = (): ReactElement => {
  const [address] = useBFSMValue<
    AddressState,
    AddressActions.Next,
    'address'
  >('address')
  const [calPartner] = useBFSMValue<
    CalendarState,
    CalendarActions.SetPartner,
    'partner'
  >('partner')
  const [packPartner] = useBFSMValue<
    PackageState,
    PackageActions.SetPartner,
    'partner'
  >('partner')
  const [serviceType] = useBFSMValue<
    CalendarState,
    CalendarActions.SetServiceType,
    'serviceType'
  >('serviceType')

  const partner = calPartner ? calPartner : packPartner
  const isFreeConsultation = serviceType
    ? (serviceType as ServiceBF).freeConsultation
    : false

  const onClickReset = () => {
    window.location.reload()
  }

  return (
    <AddressResetTemplate
      address={address!.address}
      onClickReset={onClickReset}
      partner={partner! as PartnerBF}
      isFreeConsultation={isFreeConsultation}
    />
  )
}

export default AddressResetPage
